import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Site Investigation & Feasibility",
  description: "Subsurface soil investigations\nSoil borings (SPT drilling) \xA0\nTest pits and soil profiling \xA0\nGroundwater observations\nPreliminary site feasibility\nevaluations Bearing capacity analysis Foundation design recommendations Geotechnical engineering reportsAdvanced structural restoration for industrial metal roofing systems. We eliminate corrosion, secure loose panels, and apply high-performance sealants for long-term durability in industrial environments.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/commercial_metal_roof_detail.png",
  link: "/IntakeFormPage"
}, {
  title: "Industrial Membrane Seals",
  description: "High-accuracy patching and seam reinforcement for TPO and EPDM systems. Our clean-room approach ensures zero-defect bonding and thermal efficiency for critical commercial facilities.\n\n\n\n\n\n\n\n\n\n",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/commercial_tpo_roof_detail.png",
  link: "/IntakeFormPage"
}, {
  title: "Structural Deck Restoration",
  description: "Comprehensive assessment and repair of load-bearing roof decks. We restore structural integrity using heavy-duty materials designed to withstand extreme industrial operations.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/commercial_epdm_roof_detail.png",
  link: "/IntakeFormPage"
}, {
  title: "Subsurface soil investigations",
  description: "Subsurface soil investigations",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/default_service.png",
  link: "/IntakeFormPage"
}, {
  title: "Soil borings (SPT) and test pits",
  description: "Soil borings (SPT) and test pits",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/default_service.png",
  link: "/IntakeFormPage"
}, {
  title: "Groundwater evaluation",
  description: "Groundwater evaluation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/default_service.png",
  link: "/IntakeFormPage"
}, {
  title: "Bearing capacity analysis",
  description: "Bearing capacity analysis",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/default_service.png",
  link: "/IntakeFormPage"
}, {
  title: "Geotechnical engineering reports",
  description: "Geotechnical engineering reports",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569221/img/default_service.png",
  link: "/IntakeFormPage"
}];
export default function CommercialRepairServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}